import { mapActions, mapState } from 'vuex';
  
import AppGravarContaDialog from './dialogs/GravarContaDialog.vue';
import AppGravarVisitaDialog from './dialogs/GravarVisitaDialog.vue';
import AppGravarRepresentanteDialog from '../../shared/dialogs/GravarRepresentanteDialog.vue';
import AppEditarContatoRealizadoDialog from './dialogs/EditarContatoRealizadoDialog.vue';
import AppGravarContatoRealizadoDialog from './dialogs/GravarContatoRealizadoDialog.vue';
import AppAdicionarContatosAdicionaisDialog from  '../../shared/dialogs/AdicionarContatosAdicionaisDialog.vue'
import AppCriarDiretorioArquivoDialog from "../../shared/dialogs/CriarDiretorioArquivoDialog.vue";
import AppSelecionarDiretorioArquivoDialog from "../../shared/dialogs/SelecionarDiretorioArquivosDialog.vue"; 

import AppUploadArquivoDialog from '../../shared/dialogs/UploadArquivoDialog.vue';  
import AppGravarObservacaoDialog from '../../shared/dialogs/GravarObservacaoDialog.vue';


import Util from '../../util/funcoes.js';
import { ESTADOS, ESTADO_CIVIL, CATEGORIA_CLIENTE, OPERACAO_IMOVEL, STATUS_IMOVEL, TIPOS_CONTATOS, EMAIL_REGEX } from '../../util/constantes.js';
import { Money } from "v-money";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolder, faFile } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFolder,faFile)

export default {
  components: {
    AppEditarContatoRealizadoDialog,  
    AppGravarContatoRealizadoDialog,
    AppAdicionarContatosAdicionaisDialog,
    AppGravarContaDialog,
    AppUploadArquivoDialog,
    AppGravarVisitaDialog,
    AppGravarRepresentanteDialog,
    AppGravarObservacaoDialog,
    AppCriarDiretorioArquivoDialog,
    AppSelecionarDiretorioArquivoDialog,
    FontAwesomeIcon,
    Money
  },
  created() {
    if(this.clienteNovo) this.configurarCampoAtendente();
  },
  data() {
    return {
      infiniteLoadingId: 0,
      infiniteLoadingIdLog: 0,

      validacao: {
        nome: [
          { required: true, message: "Nome é obrigatório" },
        ],
        celular: [
          { required: true, message: "Telefone é obrigatório", validator: this.validadorTelefoneCelular },
        ],
        cpfCnpj: [
          { required: true, message: "CPF/CNPJ é obrigatório", validator: this.validadorCpfCnpj }
        ],
        email: [
          { required: true, validator: this.validarEmail },
        ],
      },

      imovel: {},

      visitaSelecionada: undefined,

      conta: {
        status: "",
        banco: "",
        tipo: "",
        titular: "",
        agencia: "",
        numeroConta: ""
      },
      perfis: [],

      loadingUsuarios: false,

      visibilidadeGravarContatoRealizadoDialog: false,
      visibilidadeEditarContatoRealizadoDialog: false,
      visibilidadeGravarContaDialog: false,
      visibilidadeUploadArquivoDialog: false,
      visibilidadeGravarVisitaDialog: false,
      visibilidadeGravarRepresentanteDialog: false,
      visibilidadeAdicionarContatoAdicionalDialog: false,          
      visibilidadeGravarObservacaoDialog: false,
      visibilidadeEditarVisitaDialog: false,
      visibilidadeCriarDiretorioDialogArquivo: false,
      visibilidadeSelecionarDiretorioArquivoDialog: false,

      motivoFinalizacaoContato: undefined,


      //Editar Contato
      contatoSelecionado: {},

      contatoRealizado: {
        dataProximoContato: undefined
      },
      dataProximoContato: "",

      //Contato Adicional
      contatoAlternativo: {},
      indexContatoAlternativo: 0,

      //Editar Conta
      contaBancariaEmEdicao: {},

      //Observação
      observacaoSelecionada: {},
      observacaoEmEdicao: undefined,
      filtroObservacoes: '',

      //Editar Visita
      visita: {},
      horaVisita: "",
      dataVisita: "",
      imoveisVisita: {},

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      defaultProps: {
        label: 'label',
        children: 'children',
      },
      arquivoSelecionado: undefined,
      arquivosProps: {
        label: "nome",
        children: "arquivos"
      },
      keysArquivo: ["usuario","descricao","data","localizacaoFisica", "extensao"],
      
      tabSelecionada: "detalhes",
      tabKey: 0,

      hoverGravar: false,
      hoverRemover: false,

      representanteRecuperado: undefined
    }
  },
  computed: {
    ...mapState('vendasClientesStore', {
      clientes(state) { return state.listaClientes },
      clientePesquisa(state) { return state.clientePesquisa },
      labelQuantidade(state) { return state.labelQuantidade },

      cliente(state) { return state.clienteSelecionado },
      logs(state) { return state.logs },
      logPesquisa(state) { return state.logPesquisa },
      arquivos(state){ return state.clienteSelecionado.diretorios},
      usuariosDisponiveis(state) { return state.usuariosDisponiveis },
    }),
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_VENDA" })[0] },
      permissoesImoveisAluguel(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "IMOVEIS_ALUGUEL" })[0] },
    }),

    clienteNovo() { 
      return this.cliente.id == 0 
    },

    isPessoaFisica() {
      return this.cliente.personalidadeJuridica === 'PESSOA_FISICA';
    },
    isPessoaJuridica() {
      return this.cliente.personalidadeJuridica === 'PESSOA_JURIDICA';
    },
    
    estados() { 
      return ESTADOS.filter(estado => { return estado.pais.id === 1 });
    },
    estadoCivil() {
      return ESTADO_CIVIL;
    },
    categoriaCliente() {
      return CATEGORIA_CLIENTE;
    },
    operacaoImovel() {
      return OPERACAO_IMOVEL
    },
    statusImovel() {
        return STATUS_IMOVEL
    },
    disableRadio() {
      return this.cliente.id != 0
    },
    perfisDisponiveis() {
      var auxSetPerfis = new Set();      
      var auxArrayPerfis = new Array();
      var auxPerfis = this.cliente.perfis.filter(item => {
        return item.imovel.operacao === 'VENDA'
      });
      var auxObjPerfis, auxObjStatus;
      var i;
      
      for (i = 0; i < auxPerfis.length; i++) {
        auxSetPerfis.add(this.formatarString(auxPerfis[i].perfil.toString()));        
      }
      
      auxSetPerfis.forEach(function (value) {
        auxObjPerfis = new Object();
        auxObjPerfis["label"] = " " + value;
        auxObjPerfis["children"] = [];
        var auxSetStatus = new Set();

        auxPerfis.forEach(function (item) {
          if(item.perfil.toString().toLowerCase() == value.toLowerCase()){
            let str = item.imovel.status.toString();            
            auxSetStatus.add(str[0].toUpperCase() + str.substring(1).toLowerCase());
          }
        })

        auxSetStatus.forEach(function (valueStatus) {
          //Tratamento da label de status do imovel
          let str = valueStatus.split('_');
          for (var i = 0, x = str.length; i < x; i++) {
           str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
          }

          auxObjStatus = new Object();
          auxObjStatus["perfil"] = value;
          //definir label status do imovel
          auxObjStatus["label"] = " " + str.join(" ");
          auxObjStatus["children"] = [];

          auxPerfis.forEach(function (item) {
            if(item.perfil.toString().toLowerCase() == value.toLowerCase() && item.imovel.status.toString().toLowerCase() == valueStatus.toLowerCase()){
              auxObjStatus["children"].push(item.imovel);
            }
          })
          auxObjPerfis["children"].push(auxObjStatus)
        });

        auxArrayPerfis.push(auxObjPerfis);
      });
      return auxArrayPerfis;
    },

    observacoesFiltradas() {
      return this.cliente.observacoes
        .filter(this.filtrarObservacoes);
    },
    //CLIENTE
    exibirCamposPessoaFisica() {
      return this.cliente.personalidadeJuridica == "PESSOA_FISICA";
    },
    exibirCamposPessoaJuridica() {
      return this.cliente.personalidadeJuridica == "PESSOA_JURIDICA";
    },
    exibirCamposConjuge() {
      return this.cliente.personalidadeJuridica == "PESSOA_FISICA" && ['CASADO', 'UNIAO_ESTAVEL'].includes(this.cliente.estadoCivil);
    },
    exibirBotaoGravarCliente() {
      return (
        (this.permissoes.cadastro && this.cliente.id == 0) ||
        (this.permissoes.alteracao && this.cliente.id != 0)
      );
    },
    exibirImovelSelecionado(){
      return !this.imovel.id == 0;
    },
    exibirBotaoRemoverCliente() {
      return (
        this.cliente.id != 0 &&
        this.permissoes.remocao
      );
    },
    desabilitarCampoAtendente() {
      return !this.permissoes.alteracaoCorretor;
    },
    //CONTATOS REALIZADOS
    exibirBotaoNovoContato() {
      return this.tabSelecionada == "contatos"
    },
    exibirBotaoFinalizarContato() { 
      return (
        this.tabSelecionada == "contatos" &&
        this.contatoSelecionado &&
        this.contatoSelecionado.id !== 0 &&
        this.contatoSelecionado.status === "EM_ANDAMENTO"
      );
    },
    //CONTAS BANCÁRIAS
    exibirBotaoNovaConta(){
      return (
        this.tabSelecionada == "contas" && 
        !this.permissoes.alteracaoClienteComExcecaoContaBancaria
        )
    },
    //VISITAS
    exibirBotaoNovaVisita(){
      return this.tabSelecionada == "visitas"
    },
    //ARQUIVOS
    linhasArquivo(){
      if(this.arquivoSelecionado){
        return Object.entries(this.arquivoSelecionado)
        .filter(([key]) => this.keysArquivo.includes(key) )
        .map(([key,value]) => ({key, value})).sort((a, b ) => {
          if(a.key === "localizacaoFisica"){
            return 1
          }
          if(b.key === "localizacaoFisica"){
            return -1
          }
        })
      }      
    },
    exibirBotaoUploadArquivo(){
      return this.tabSelecionada == "arquivos"
    },
    dadosPesquisaCliente(){
      return (
        this.clientePesquisa.categoriaPesquisa != "" ||
        this.clientePesquisa.id != "" || 
        this.clientePesquisa.nome != "" || 
        this.clientePesquisa.telefone != "" || 
        this.clientePesquisa.cpfCnpj != ""
        )
    },
    // UTIL
    maskCpfCnpj() {
      if(this.cliente.personalidadeJuridica === 'PESSOA_FISICA'){
        return '###.###.###-##'
    } else {
        return '##.###.###/####-##'
    }
    },
    exibirAlertaCpfInvalido(){
      return !Util.validarCpf(this.cliente.cpfCnpj) && this.cliente.cpfCnpj.length === 14;
    }
  },
  
  watch: {
    clienteNovo(newValue) {
      if(newValue) {
        this.tabSelecionada = "detalhes"
        this.tabKey++;
      }
    },
    'cliente.id': function(newValue, oldValue) {
      if(newValue != oldValue) {
        this.tabSelecionada = "detalhes";
        this.imovel = {
          id: 0,
          perfil: "",
          endereco: "",
          numeroEndereco: "",
          operacao: "",
          bairro: {
            cidade: "",
            nome: "",
            zona: "",
          }
        };
        this.limparContato()
        this.observacaoSelecionada = {};
      }         
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('vendasClientesStore', [
      'novoCliente',
      'limparClientePesquisa',
      'limparClientesListados',
      'pesquisarClientes',
      'recuperarClienteVenda',
      'gravarCliente',
      'reativarCliente',
      'removerCliente',

      'listarUsuarios',

      'gravarContatoRealizado',
      'atualizarContatoRealizado',
      'removerContatoRealizado',
      
      'gravarConta',
      'removerConta',

      'gravarVisita',
      'recuperarVisita',
      'removerVisita',

      'recuperarLogs',
      'limparLogPesquisa',

      'recuperarObservacaoCliente',
      'removerObservacao',

      'removerArquivo',
      'removerDiretorioArquivos',
    ]),
    ...mapActions('vendasImoveisStore', [
      'recuperarImovel'
    ]),
    ...mapActions('alugueisImoveisStore', 
      {recuperarImovelAluguel:'recuperarImovel'}
    ),
    configurarCampoAtendente() {
      this.cliente.usuario = this.usuarioLogado;

      const usuarioLogadoNotInUsuariosDisponiveis = !this.usuariosDisponiveis.map(usuario => usuario.id)
        .includes(this.usuarioLogado.id);
      
      if(usuarioLogadoNotInUsuariosDisponiveis) {
        this.usuariosDisponiveis.push(this.usuarioLogado);
      }
    },
    novoClienteHandler() {
      this.novoCliente();
      this.configurarCampoAtendente();
    },
    //PESQUISA
    pesquisarHandler() {
      this.clientePesquisa.pagina = 0;
      this.limparClientesListados();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if(this.clientePesquisa.pagina == 0) { this.showLoading(); }

      if(this.permissoes.visualizacaoSomenteClientesCorretor){
        this.clientePesquisa.usuario = { id: this.usuarioLogado.id }
      }

      this.pesquisarClientes(this.clientePesquisa)
      .then((resultado) => {
        if(this.clientePesquisa.pagina == 0) { this.hideLoading(); }
        
        if(resultado.lista.length == 100) {
          this.clientePesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.clientePesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      });
    },
    recuperarHandler(cliente) {
      this.recuperar(cliente);
    },
    recuperar(cliente) {
      this.irParaSecao();
      const payload = { id: cliente.id };
      this.showLoading();

      this.recuperarClienteVenda(payload)
      .then((resultado) => {
        switch(resultado.status) {
          case "SUCESSO":
          case "FALHA":
          case "ERRO":
            this.hideLoading();
            break;
        }
      })
    },
    // RESUMO 
    selecionarImovel(node) {
      this.imovel = node;
    },

    recuperarImovelSelecionado(node) {
      if(this.permissoesImoveisAluguel.visualizacao === false && node.data.operacao == 'ALUGUEL') {
        this.$message.warning('Este usuário não tem permissão para acessar imóveis de aluguel!')
        return
      }

      this.imovelSelecionado = node.data
      let payload = { id: this.imovelSelecionado.id };
      
      if(node.data.operacao === 'ALUGUEL') {
        this.recuperarImovelAluguelHandler(payload)
      } else {
        this.recuperarImovelVendaHandler(payload)
      }
    },

    recuperarImovelAluguelHandler(payload) {
      this.showLoading();
      this.recuperarImovelAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          if(resultado.status == "SUCESSO") {
            this.$router.push("/alugueis/imoveis");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
    },

    recuperarImovelVendaHandler(payload) {
      this.showLoading();
      this.recuperarImovel(payload)
        .then(resultado => {
          this.hideLoading();
          if(resultado.status == "SUCESSO") {
            this.$router.push("/imoveis");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
    },
    //CADASTRO
    getLabel(array, element) {
      return Util.getLabel(array, element);
    },
    tabClicked(tab) {
      if(tab.name == "logs") {
        this.limparLogPesquisa();
        this.infiniteLoadingIdLog += 1;
        let payload = { cliente: { id: this.cliente.id }, pagina: 0 }
        
        this.recuperarLogs(payload).catch(() => {
          this.$message.error("Não foi possível recuperar os logs deste cliente");
        });
      }
      if(tab.name != "contatos") {
        this.limparContato()
      }
    },
    //DETALHES - REPRESENTANTE
    exibirGravarRepresentanteDialog() {
      this.visibilidadeGravarRepresentanteDialog = true
    },
    fecharGravarRepresentanteDialog(args) {
      this.representanteRecuperado = undefined
      if(args.representante) {
        this.cliente.representantes.push(args.representante);
      } else if(args.isRecuperarCliente) {
        this.recuperarClienteVenda({ id: this.cliente.id })
      }
      this.visibilidadeGravarRepresentanteDialog = false;
    },
    exibirEditarRepresentanteDialog(representante) {
      this.representanteRecuperado = Object.assign({}, representante);

      this.visibilidadeGravarRepresentanteDialog = true;
    },
    //DETALHES - Contato Adicional
    formatarTipoContatoAdicional(contato) {
      return Util.getLabel(TIPOS_CONTATOS, contato.tipo);
    },
    exibirAdicionarNovoContatoAdicionalDialog() {
      this.contatoAlternativo = {}
      this.visibilidadeAdicionarContatoAdicionalDialog = true
    },
    exibirAdicionarContatoAdicionalDialog(contato) {
      var i;
      this.showLoading();
      for(i=0; i < this.cliente.contatosAlternativos.length; i++){
        if(this.cliente.contatosAlternativos[i] === contato){
          this.indexContatoAlternativo = i;
        }
      }
      this.contatoAlternativo = Object.assign({}, contato);
      this.visibilidadeAdicionarContatoAdicionalDialog = true
      this.hideLoading();
    },
    fecharAdicionarContatoAdicionalDialog() {
      this.visibilidadeAdicionarContatoAdicionalDialog = false;
    },

    validadorTelefoneCelular(rule, value, callback) {
      if(value) {
        return callback();
      } else {
        if(this.cliente.telefone) {
          return callback();
        } else {
          return callback(new Error());
        }
      } 
    },

    cpfIsValido(cpf) {
      return Util.validarCpf(cpf);
    },

    cnpjIsValido(cnpj) {
      if(!cnpj) return false;
      
      return cnpj.length === 18;
    },

    validadorCpfCnpj(rule, value, callback) {
      if(this.cliente.personalidadeJuridica === 'PESSOA_FISICA') {
        if(this.cpfIsValido(value)) {
          return callback();
        } else {
          return callback(new Error());
        }
      } else {
        if(this.cnpjIsValido(value)) {
          return callback();
        } else {
          return callback(new Error());
        }
      }
    },

    validarEmail(rule, value, callback) {
      const emailPattern = EMAIL_REGEX;

      if(!value || value.trim() === '') {
        return callback();
      }

      if(emailPattern.test(value)) {
        return callback();
      }

      return callback(new Error());
    },

    gravarHandler() {
      this.$refs['form'].validate(isValid => {
        const pessoaJuridicaSemRepresentantes = isValid
          && this.cliente.personalidadeJuridica === 'PESSOA_JURIDICA'
          && this.cliente.representantes.length === 0;

        if (pessoaJuridicaSemRepresentantes) {
          this.exibirAlert('Atenção', 'Você deve cadastrar ao menos um representante da pessoa jurídica');
          return;
        }

        const formIsNotValid = !isValid;
        if (formIsNotValid) {
          this.exibirAlert('Atenção', 'Preencha todos os campos obrigatórios');
          return;
        }

        this.gravar();
      });
    },
    
    getPayloadGravarCliente() {
      if(this.isPessoaFisica) return this.getPayloadGravarClientePessoaFisica();
      if(this.isPessoaJuridica) return this.getPayloadGravarClientePessoaJuridica();
    },

    getPayloadGravarClientePessoaFisica() {
      return {
        id: this.cliente.id,
        versao: this.cliente.versao,
        imobiliaria: this.cliente.imobiliaria,
        idNaImobiliaria: this.cliente.idNaImobiliaria,
        personalidadeJuridica: this.cliente.personalidadeJuridica,
        nome: this.cliente.nome,
        cpfCnpj: this.cliente.cpfCnpj,
        rg: this.cliente.rg,
        dataNascimento: this.cliente.dataNascimento,
        estadoCivil: this.cliente.estadoCivil,
        sexo: this.cliente.sexo,
        nacionalidade: this.cliente.nacionalidade,
        profissao: this.cliente.profissao,
        rendaMensal: this.cliente.rendaMensal,
        celular: this.cliente.celular,
        telefone: this.cliente.telefone,
        email: this.cliente.email,
        usuario: this.cliente.usuario,
        endereco: this.cliente.endereco,
        numeroEndereco: this.cliente.numeroEndereco,
        complemento: this.cliente.complemento,
        cep: this.cliente.cep,
        estado: this.cliente.estado,
        cidade: this.cliente.cidade,
        bairro: this.cliente.bairro,
        enderecoComercial: this.cliente.enderecoComercial,
        numeroEnderecoComercial: this.cliente.numeroEnderecoComercial,
        complementoComercial: this.cliente.complementoComercial,
        cepComercial: this.cliente.cepComercial,
        estadoComercial: this.cliente.estadoComercial,
        cidadeComercial: this.cliente.cidadeComercial,
        bairroComercial: this.cliente.bairroComercial,
        nomeConjuge: this.cliente.nomeConjuge,
        cpfConjuge: this.cliente.cpfConjuge,
        rgConjuge: this.cliente.rgConjuge,
        emailConjuge: this.cliente.emailConjuge,
        profissaoConjuge: this.cliente.profissaoConjuge,
        nacionalidadeConjuge: this.cliente.nacionalidadeConjuge,
        contatosAlternativos: this.cliente.contatosAlternativos,
        contatosRealizados: this.cliente.contatosRealizados,
        contasBancarias: this.cliente.contasBancarias,
        arquivos: this.cliente.arquivos,
        visitas: this.cliente.visitas,
      };
    },

    getPayloadGravarClientePessoaJuridica() {
      return {
        id: this.cliente.id,
        versao: this.cliente.versao,
        imobiliaria: this.cliente.imobiliaria,
        idNaImobiliaria: this.cliente.idNaImobiliaria,
        personalidadeJuridica: this.cliente.personalidadeJuridica,
        nome: this.cliente.nome,
        cpfCnpj: this.cliente.cpfCnpj,
        celular: this.cliente.celular,
        telefone: this.cliente.telefone,
        email: this.cliente.email,
        usuario: this.cliente.usuario,
        endereco: this.cliente.endereco,
        numeroEndereco: this.cliente.numeroEndereco,
        complemento: this.cliente.complemento,
        cep: this.cliente.cep,
        estado: this.cliente.estado,
        cidade: this.cliente.cidade,
        bairro: this.cliente.bairro,
        enderecoComercial: this.cliente.enderecoComercial,
        numeroEnderecoComercial: this.cliente.numeroEnderecoComercial,
        complementoComercial: this.cliente.complementoComercial,
        cepComercial: this.cliente.cepComercial,
        estadoComercial: this.cliente.estadoComercial,
        cidadeComercial: this.cliente.cidadeComercial,
        bairroComercial: this.cliente.bairroComercial,
        representantes: this.cliente.representantes,
        contatosAlternativos: this.cliente.contatosAlternativos,
        contatosRealizados: this.cliente.contatosRealizados,
        contasBancarias: this.cliente.contasBancarias,
        arquivos: this.cliente.arquivos,
        visitas: this.cliente.visitas,
      };
    },

    gravar() {
      const payload = this.getPayloadGravarCliente();
      this.showLoading();

      this.gravarCliente(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            if(resultado.mensagem.includes('reativá-lo')){
              this.reativarClienteHandler(resultado.mensagem)
            } else {
                this.$message.warning(resultado.mensagem);
            }
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    reativarClienteHandler(mensagem) {
      this.$confirm(mensagem, 'Atenção', {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
      }).then(() => {
          this.reativar();
      });
    },
    reativar() {
        this.showLoading();
        this.reativarCliente(this.cliente).then(resultado => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.pesquisarHandler();
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                case "ERRO":
                    this.$message.error(resultado.mensagem);
                    break;
            }
        });
    },
    removerClienteHandler() {
      this.$confirm('Deseja realmente remover este cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      this.removerCliente(this.cliente)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },

    removerRepresentante(representante) {
      this.$confirm('Deseja remover este Representante?', 'Atenção', {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
      }).then(() => {
          this.cliente.representantes = this.cliente.representantes.filter((elemento) => { return elemento != representante });
      }).catch(() => {});
    },
    removerContatoAdicional(contato) {
        this.$confirm('Deseja remover este Contato Adicional?', 'Atenção', {
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            type: 'warning'
        }).then(() => {
            this.cliente.contatosAlternativos = this.cliente.contatosAlternativos.filter((elemento) => { return elemento != contato });
        }).catch(() => {});
        
    },
    atualizaConta(row){
      this.conta.status = row.status;
      this.conta.banco = row.banco;
      this.conta.tipo = row.tipo;
      this.conta.titular = row.titular;
      this.conta.agencia = row.agencia;
      this.conta.numeroConta = row.conta;
    },
    //SELECT
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload)
      .then(() => {
        this.loadingUsuarios = false;  
      })
    },      
    //CONTATOS REALIZADOS
    coresStatusContatoRealizado(status) {
      switch(status) {
        case "CONCLUIDO":
          return "#2DB748";
        case "EM_ANDAMENTO":
          return "#FF9E29";
      }
    },
    atualizaContato(contato) {
      this.contatoSelecionado = contato;
    },
    handlerFinalizarContato(){
      this.$prompt("Motivo da Finalização", "Atenção", {
        confirmButtonText: 'Finalizar',
        cancelButtonText: 'Cancelar'
      }).then(({ value }) => {      
        if(value === null){value = "Não Informado"}
        this.motivoFinalizacaoContato = value
        this.finalizarContatoRealizado();
      })
    },
    finalizarContatoRealizado(){
      this.$confirm('Deseja realmente finalizar este contato com o cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let auxContato = {
          status: "CONCLUIDO",
          id: this.contatoSelecionado.id,
          descricao: this.contatoSelecionado.descricao,
          cliente: {
            id: this.cliente.id
          },
          assunto: this.contatoSelecionado.assunto,
          motivoFinalizacao: this.motivoFinalizacaoContato 
        };      
        this.showLoading();
        this.atualizarContatoRealizado(auxContato)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
      })
    },
    removerContatoHandler(contatoRealizado) {
      this.$confirm('Deseja realmente remover este contato com o cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerContato(contatoRealizado);
      }).catch(() => {});
    },
    removerContato(contatoRealizado) {
      this.showLoading();
      this.removerContatoRealizado(contatoRealizado)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.contatoSelecionado = {};
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
    },
    exibirGravarContatoRealizadoDialog(tipo) {
      if (tipo && tipo === 'NOVO') {
        this.contatoSelecionado = {}
        this.visibilidadeGravarContatoRealizadoDialog = true
      } else {
        //if (this.contatoSelecionado.status === 'CONCLUIDO') {
          //this.$message.warning("Não é possível editar contato concluído!");
        //} else {
          this.visibilidadeGravarContatoRealizadoDialog = true
        //}
      }
    },
    fecharGravarContatoRealizadoDialog() {
      this.visibilidadeGravarContatoRealizadoDialog = false;
    },
    //CONTAS
    removerContaBancariaHandler(conta) {
      this.$confirm('Deseja realmente remover esta conta bancária do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerContaBancaria(conta);
      }).catch(() => {});
    },
    removerContaBancaria(conta) {
      this.showLoading();
      this.removerConta(conta)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })        
    },
    exibirGravarContaDialog() {
      this.contaBancariaEmEdicao = undefined;
      this.visibilidadeGravarContaDialog = true
    },
    fecharGravarContaDialog() {
      this.visibilidadeGravarContaDialog = false;
    },
    editarContaBancaria(conta) {
      const usuarioPodeEditarConta = !this.permissoes.alteracaoClienteComExcecaoContaBancaria;
      if(usuarioPodeEditarConta) {
        this.contaBancariaEmEdicao = Object.assign({}, conta);
        this.showLoading();
        this.visibilidadeGravarContaDialog = true;
        this.hideLoading();
      }
    },
    //OBSERVAÇÕES
    removerObservacaoHandler(observacao) {
      this.$confirm('Deseja realmente remover esta observação do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let payload = { id: observacao.id }        
        this.showLoading();
        this.removerObservacao(payload)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.observacaoSelecionada = {}
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
      })
    },
    alterarObservacao(observacao, column) {
      if(column.columnKey == "acoes") { return }
      if(!this.permissoes.alterarObservacoes) { return }
      if(this.permissoes.alterarObservacoesSomenteCorretor && observacao.usuario.id !== this.usuarioLogado.id) { return }

      let payload = { id: observacao.id };

      this.showLoading();
      this.recuperarObservacaoCliente(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.observacaoEmEdicao = resultado.item;
            this.observacaoSelecionada = {};
            this.visibilidadeGravarObservacaoDialog = true;
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },    
    exibirGravarObservacaoDialog() { 
      this.observacaoEmEdicao = undefined
      this.visibilidadeGravarObservacaoDialog = true; 
    },
    fecharGravarObservacaoDialog() { 
      this.visibilidadeGravarObservacaoDialog = false; 
    },
    exibirObservacao(observacaoSelecionada) {
      this.observacaoSelecionada = observacaoSelecionada 
    },
    exibirColunaRemoverObservacao() {
      return (
        this.permissoes.removerObservacoes
      );
    },      
    //ARQUIVOS
    exibirDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = true;
    },
    fecharDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = false;
    },
    exibirBotaoRemoverDiretorioArquivo(data) {
      return data.nome !== "Outros";
    },
    selecionarArquivo(arquivoSelecionado) {
      if(arquivoSelecionado !== undefined && arquivoSelecionado.descricao !== null) {
        this.arquivoSelecionado = arquivoSelecionado;
      }
    },
    labelPropriedades(key){
      switch (key) {
        case "usuario":
          return "Usuário";
        case "data":
          return "Envio";
        case "localizacaoFisica":
          return "Observações";    
        case "descricao":
          return "Nome";
        case "extensao":
          return "Extensao do Arquivo"
        default:
          break;
      }
    },
    removerArquivosHandler(data){
      if(data.descricao){
        this.removerArquivoHandler(data)
      }else{
        this.removerDiretorioArquivosHandler(data)
      }
    },
    removerDiretorioArquivosHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorioArquivo(diretorio);
      });
    },
    removerDiretorioArquivo(diretorio) {
      let payload = { id: diretorio.id, idCliente: this.cliente.id};

      this.showLoading();
      this.removerDiretorioArquivos(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    formatarLabelArquivo(arquivo) {
      if(arquivo.descricao != undefined){
        return "normal";
      }
      return "bold";
    },

    formatarIconeTreeArquivo(arquivo) {
      if(arquivo.descricao != undefined) {
        return 'el-icon-document'
      }
      return 'el-icon-folder-opened'
    },
    exibirDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = true;
    },
    fecharDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = false;
    },
    removerArquivoHandler(arquivo) {
       this.$confirm('Deseja realmente remover este arquivo do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let payload = { id: arquivo.id };
        this.showLoading();
        this.removerArquivo(payload)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERROR":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
      })
    },
    downloadArquivoHandler(arquivo) {
      window.open(arquivo.path, "_blank");
    },
    exibirDialogUploadArquivo() { 
      this.visibilidadeUploadArquivoDialog = true 
    },
    fecharDialogUploadArquivo() { 
      this.visibilidadeUploadArquivoDialog = false; 
    },
    //VISITAS
    removerVisitaHandler(visita) {
      this.$confirm('Deseja realmente remover esta visita do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerVisitaCliente(visita);
      }).catch(() => {});
    },
    removerVisitaCliente(visita){
      this.showLoading();
      this.removerVisita(visita)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;            
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
    },
    exibirGravarVisitaDialog() {
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = true
    },
    fecharGravarVisitaDialog() {
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = false;
    },
    alterarVisita(visita, column) {
      if(column.columnKey == "acoes") { return; }

      let payload = { id: visita.id };

      this.showLoading();
      this.recuperarVisita(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.visitaSelecionada = resultado.item;
            this.visibilidadeGravarVisitaDialog = true;
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },

    //HELPER FUNCTIONS
    pesquisarLogs($state) {
      if(this.logPesquisa.pagina == 0) { this.showLoading(); }
      this.logPesquisa.cliente = { id: this.cliente.id }
      this.recuperarLogs(this.logPesquisa)
      .then((resultado) => {
          if(this.logPesquisa.pagina == 0) { this.hideLoading(); }
        
          if(resultado.lista.length == 100) {
              this.logPesquisa.pagina += 1;
              $state.loaded();
          } else if(resultado.lista.length > 0 && this.logPesquisa.pagina == 0) {
              $state.loaded();
              $state.complete();
          } else {
              $state.complete();
          }
      });
    },
    formatarString(str) {
      str = str.split('_');
      for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
      }
      return str.join(" ");
    },
    limparPesquisa() {
      this.limparClientePesquisa();
    },
    limparContato() {
      this.contatoSelecionado = {};
    },

    filtrarObservacoes(observacao) {
      const descricao = observacao.descricao !== null ? Util.removerAcentos(observacao.descricao.trim().toLowerCase()) : '';
      const assunto = observacao.assunto !== null ? Util.removerAcentos(observacao.assunto.trim().toLowerCase()) : '';

      const searchTerm = Util.removerAcentos(this.filtroObservacoes.trim().toLowerCase());

      return descricao.includes(searchTerm) || assunto.includes(searchTerm);
    },
    irParaSecao(){
      location.href = '#novo'
    },
    retrairBotoes(){
      this.hoverRemover = false;
      this.hoverGravar = false;
    },
    expandGravar(){
      this.retrairBotoes();
      this.hoverGravar = !this.hoverGravar
    },
    expandRemover(){
     this.retrairBotoes();
    this.hoverRemover = !this.hoverRemover
    },
  }
}
